export const CERTICICATES_CLOUDE = [
  {
    img: "/images/certi_cloud1.webp",
    title: "Salesforce Administrator",
    number: "30",
  },
  {
    img: "/images/certi_cloud2.webp",
    title: "Salesforce Advanced Administrator",
    number: "14",
  },
  {
    img: "/images/certi_cloud3.webp",
    title: "Salesforce Certified Platform Associate",
    number: "6",
  },
  {
    img: "/images/certi_cloud4.webp",
    title: "Salesforce Certified AI Associate",
    number: "30",
  },
  {
    img: "/images/certi_cloud5.webp",
    title: "Salesforce Certified Agentforce Specialist",
    number: "20",
  },
  {
    img: "/images/certi_cloud6.webp",
    title: "Salesforce Certified Marketing Cloud Email Specialist",
    number: "3",
  },
  {
    img: "/images/certi_cloud7.webp",
    title: "Salesforce Certified Business Analyst",
    number: "4",
  },
  {
    img: "/images/certi_cloud8.webp",
    title: "Salesforce Platform App Builder",
    number: "25",
  },
  {
    img: "/images/certi_cloud9.webp",
    title: "Salesforce Certified Marketing Cloud Developer",
    number: "4",
  },
  {
    img: "/images/certi_cloud10.webp",
    title: "Salesforce Certified Platform Developer I",
    number: "5",
  },
  {
    img: "/images/certi_cloud11.webp",
    title: "Salesforce Certified Platform Developer II",
    number: "6",
  },
  {
    img: "/images/certi_cloud12.webp",
    title: "Salesforce Certified B2C Commerce Cloud Developer",
    number: "2",
  },
  {
    img: "/images/certi_cloud13.webp",
    title: "Salesforce Certified System Architect",
    number: "2",
  },
  {
    img: "/images/certi_cloud14.webp",
    title: "Salesforce Certified Integration Architect",
    number: "1",
  },
  {
    img: "/images/certi_cloud15.webp",
    title: "Salesforce Certified System Application Architect",
    number: "2",
  },
  {
    img: "/images/certi_cloud16.webp",
    title: "Platform Development Lifecycle & Deployment Architect",
    number: "3",
  },
  {
    img: "/images/certi_cloud17.webp",
    title: "Salesforce Certified Platform Data Architect",
    number: "2",
  },
  {
    img: "/images/certi_cloud18.webp",
    title: "Salesforce Certified Heroku Architect",
    number: "1",
  },
  {
    img: "/images/certi_cloud19.webp",
    title: "Salesforce Certified Sharing & Visibility Designer",
    number: "2",
  },
  {
    img: "/images/certi_cloud20.webp",
    title: "Salesforce Certified Data Cloud Consultant",
    number: "2",
  },
  {
    img: "/images/certi_cloud21.webp",
    title: "Salesforce Certified Tableau CRM and Einstein Discovery Consultant",
    number: "1",
  },
  {
    img: "/images/certi_cloud22.webp",
    title: "Salesforce Certified Field Service Consultant",
    number: "1",
  },
  {
    img: "/images/certi_cloud23.webp",
    title: "Salesforce Certified Sales Cloud Consultant",
    number: "15",
  },
  {
    img: "/images/certi_cloud24.webp",
    title: "Salesforce Certified Marketing Cloud Engagement Consultant",
    number: "2",
  },
  {
    img: "/images/certi_cloud25.webp",
    title: "Salesforce Certified Marketing Cloud Account Engagement Consultant",
    number: "2",
  },
  {
    img: "/images/certi_cloud26.webp",
    title: "Salesforce Service Cloud Consultant",
    number: "10",
  },
  {
    img: "/images/certi_cloud27.webp",
    title: "Salesforce Certified Experience Cloud Consultant",
    number: "2",
  },
];

export const CERTIFICATE_OTHER = [
  {
    img: "/images/certi_other1.webp",
    title: "Copado Certified DevOps Designer",
    number: "1",
  },
  {
    img: "/images/certi_other2.webp",
    title: "ISTQB Certified Tester",
    number: "2",
  },
  {
    img: "/images/certi_other3.webp",
    title: "CSTE Certified Tester",
    number: "1",
  },
];

export const CERTIFICATE_PMP = [
  {
    img: "/images/certi_pmp1.webp",
    title: "PRINCE2 Registered Practitioner",
    number: "1",
  },
];

export const CERTIFICATES_STANDARDS = [
  {
    img: "/images/certificate1.webp",
    desc: "We are ISO 27001:2022 certified, complying with legal and regulatory requirements for Cyber Security & Manage Cyber-Risks",
  },
  {
    img: "/images/certificate2.webp",
    desc: "We are ISO 9001:2015 certified,  a globally recognised standard for Quality Management",
  },
];
